export default {
  hos: {
    drivers: {
      main: "Hos.Drivers",
    },
    logs: {
      main: "Hos.Logs",
      view: "Hos.Logs.View",
      download: "Hos.Logs.Download",
      update: "Hos.Logs.Update",
      addException: "Hos.Logs.AddException",
      delete: "Hos.Logs.Delete",
      reassign: "Hos.Logs.Reassign",
      forceUpdate: "Hos.Logs.ForceUpdate",
      rollover: "Hos.Logs.Rollover",
      resize: "Hos.Logs.Resize",
    },
    violations: {
      main: "Hos.Violations",
      view: "Hos.Violations.View",
      addDocuments: "Hos.Violations.AddDocuments",
    },
    unidentifiedEvents: {
      main: "Hos.UnidentifiedEvents",
      assign: "Hos.UnidentifiedEvents.Assign",
    },
    eldDisconnections: {
      main: "Hos.EldDisconnections",
    },
    eldMalfunctions: {
      main: "Hos.EldMalfunctions",
    },
    fmcsaDataTransfer: {
      main: "Hos.FmcsaDataTransfer",
      markUnofficial: "Hos.FmcsaDataTransfer.MarkUnofficial",
    },
  },
  safety: {
    alerts: {
      main: "Safety.Alerts",
    },
  },
  locations: {
    current: {
      main: "Locations.Current",
      manageShareLinks: "Locations.Current.ManageShareLinks",
      liveTracking: "Locations.Current.LiveTracking",
    },
    history: {
      main: "Locations.History",
    },
  },
  assets: {
    dvirHistory: {
      main: "Assets.DvirHistory",
      view: "Assets.DvirHistory.View",
      manageDefects: "Assets.DvirHistory.ManageDefects",
    },
    maintenance: {
      main: "Assets.Maintenance",
      view: "Assets.Maintenance.View",
      create: "Assets.Maintenance.Create",
      update: "Assets.Maintenance.Update",
      delete: "Assets.Maintenance.Delete",
    },
    diagnostics: {
      main: "Assets.Diagnostics",
      acknowledge: "Assets.Diagnostics.Acknowledge",
    },
  },
  reports: {
    general: {
      main: "Reports.General",
      ifta: "Reports.General.Ifta",
      vehicleMileage: "Reports.General.VehicleMileage",
      vehicleDistance: "Reports.General.VehicleDistance",
      vehicleInactivity: "Reports.General.VehicleInactivity",
      locationsHistory: "Reports.General.LocationsHistory",
      eldEvents: "Reports.General.EldEvents",
    },
  },
  admin: {
    drivers: {
      main: "Administration.Drivers",
      create: "Administration.Drivers.Create",
      update: "Administration.Drivers.Update",
    },
    fleetManagers: {
      main: "Administration.FleetManagers",
      create: "Administration.FleetManagers.Create",
      update: "Administration.FleetManagers.Update",
      delete: "Administration.FleetManagers.Delete",
    },
    companies: {
      main: "Administration.Companies",
      create: "Administration.Companies.Create",
      update: "Administration.Companies.Update",
      delete: "Administration.Companies.Delete",
    },
    vehicles: {
      main: "Administration.Vehicles",
      create: "Administration.Vehicles.Create",
      update: "Administration.Vehicles.Update",
      delete: "Administration.Vehicles.Delete",
    },
    trailers: {
      main: "Administration.Trailers",
      create: "Administration.Trailers.Create",
      update: "Administration.Trailers.Update",
      delete: "Administration.Trailers.Delete",
    },
    trailerGpsProviders: {
      main: "Administration.TrailerTrackingProviders",
      create: "Administration.TrailerTrackingProviders.Create",
      update: "Administration.TrailerTrackingProviders.Update",
      delete: "Administration.TrailerTrackingProviders.Delete",
    },
    fuelProviders: {
      main: "Administration.FuelProviders",
      create: "Administration.FuelProviders.Create",
      update: "Administration.FuelProviders.Update",
      delete: "Administration.FuelProviders.Delete",
    },
    groups: {
      main: "Administration.Groups",
      create: "Administration.Groups.Create",
      update: "Administration.Groups.Update",
      delete: "Administration.Groups.Delete",
    },
    roles: {
      main: "AbpIdentity.Roles",
    },
    elds: {
      main: "Administration.Elds",
      create: "Administration.Elds.Create",
      update: "Administration.Elds.Update",
    },
    notifications: {
      main: "Administration.NotificationSubscriptions",
      create: "Administration.NotificationSubscriptions.Create",
      update: "Administration.NotificationSubscriptions.Update",
      delete: "Administration.NotificationSubscriptions.Delete",
    },
    dvirForms: {
      main: "Administration.DvirForms",
      create: "Administration.DvirForms.Create",
      update: "Administration.DvirForms.Update",
    },
    tenantRegistrations: {
      main: "Administration.TenantRegistrations",
      create: "Administration.TenantRegistrations.Create",
      update: "Administration.TenantRegistrations.Update",
      delete: "Administration.TenantRegistrations.Delete",
      deactivate: "Administration.TenantRegistrations.Deactivate",
      manage: "Administration.TenantRegistrations.Manage",
    },
    masterFleetManagers: {
      main: "Administration.MasterFleetManagers",
      create: "Administration.MasterFleetManagers.Create",
      update: "Administration.MasterFleetManagers.Update",
      delete: "Administration.MasterFleetManagers.Delete",
    },
    masterElds: {
      main: "Administration.MasterElds",
      create: "Administration.MasterElds.Create",
      update: "Administration.MasterElds.Update",
      sendCommands: "Administration.MasterElds.SendCommands",
    },
    mobileAppVersions: {
      main: "Administration.MobileAppVersions",
    },
    apiClients: {
      main: "Administration.ApiClients",
      create: "Administration.ApiClients.Create",
      update: "Administration.ApiClients.Update",
      delete: "Administration.ApiClients.Delete",
    },
    demoAccounts: {
      main: "Administration.DemoAccounts",
    },
    virtualTenants: {
      main: "Administration.VirtualTenants",
    },
  },
  master: {
    subscriptions: {
      main: "Subscriptions",
    },
  },
};
